module.exports = __webpack_public_path__ + "static/media/it-extra-large.74c0aea2.svg";